import React, { memo } from "react";
import Tooltip from "react-tooltip-lite";
import { Icon, SpacingBox } from "../../../components";
import "../styles/FieldTooltip.css";
import Card from "../../../components/Card/Card";
import infoCircle from '../../../assets/images/icons/info-circle.svg'

const FieldTooltip = ({ content }) => {
    const handleOnIconClick = event => {
        event.preventDefault();
    };
    return (
        <SpacingBox ml="10">
            <Tooltip
                className="field-tooltip"
                content={<Card className="field-tooltip__content">{content}</Card>}
                arrow={false}
                direction="middle"
            >
                <Icon
                    aria-label="Information"
                    role="button"
                    showTitle={false}
                    name="info-circle"
                    image={infoCircle}
                    onClick={handleOnIconClick}
                />
            </Tooltip>
        </SpacingBox>
    );
};

export default memo(FieldTooltip);
